import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ReCaptchaV3Service } from 'ngx-captcha';
import { SnackbarMessageComponent } from 'src/app/components/snackbar-message/snackbar-message.component';
import { TermsDialogComponent } from 'src/app/dialog/terms-dialog/terms-dialog.component';
import { STATUS } from 'src/app/enums/status.enum';
import { DataService } from 'src/app/services/data.service';
import { LoadingService } from 'src/app/services/loading.service';
import { UserService } from 'src/app/services/user.service';
import { UtilityService } from 'src/app/services/utility.service';
import { fade, fadeOp } from 'src/app/util/animations.util';
import { checkPasswords } from 'src/app/util/check-passwords.util';
import { environment } from 'src/environments/environment';

const STRONG_PASSWORD: RegExp = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%*]).{8,15}$/;

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: [
    '../../../sign-in/components/sign-in/sign-in.component.css',
    './register.component.css'
  ],
  animations: [
    fadeOp,
    fade
  ]
})
export class RegisterComponent implements OnInit {
  MSGResponse: string;
  version = '';
  imageUrl: any;
  submitted: boolean = false;
  captchaResponse: string;
  // firstName: FormControl = new FormControl("", Validators.required);
  // lastName: FormControl = new FormControl("", Validators.required);
  email: FormControl = new FormControl("", [Validators.required, Validators.email]);
  password: FormControl = new FormControl("", [Validators.required, Validators.pattern(STRONG_PASSWORD)]);
  confirmPassword: FormControl = new FormControl("", [Validators.required, Validators.pattern(STRONG_PASSWORD)]);
  // gender: FormControl = new FormControl("", Validators.required)
  passwordGroup: FormGroup = new FormGroup({
    password: this.password,
    confirmPassword: this.confirmPassword
  }, { validators: checkPasswords })
  registerForm: FormGroup = new FormGroup({
    // firstName: this.firstName,
    // lastName: this.lastName,
    email: this.email,
    // gender: this.gender,
    passport_pic: new FormControl(""),
    password: this.passwordGroup,
  });
  siteKey: string;
  isAgree: AbstractControl;
  constructor(
    private userService: UserService,
    private dataService:DataService,
    private router: Router,
    private recaptchaV3: ReCaptchaV3Service,
    private utility: UtilityService,
    private snackbar: MatSnackBar,
    private loadingService: LoadingService,
    private fb: FormBuilder,
    private dialog: MatDialog
  ) {
    this.version = this.dataService.getVersion();
    this.isAgree = this.fb.control(false);
  }

  ngOnInit(): void {
    this.siteKey = environment.RECAPTCHA_SITE_KEY;
  }

  onSubmit() {
    this.submitted = true;
    if (this.loadingService.isLoading || this.registerForm.invalid)
      return this.registerForm.markAllAsTouched();
    const user = this.registerForm.value;
    this.loadingService._setLoading();
    this.recaptchaV3.execute(this.siteKey, 'homepage', (token) => {
      const payload = {
        // first_name: user.firstName,
        // last_name: user.lastName,
        email: user.email,
        phone_number: user.phone_number,
        // gender: user.gender,
        password: user.password.password,
        recaptcha_v3_token: token
      };
      this.userService.register(payload)
      .subscribe({
        next: data => {
          this.loadingService._clearLoading();
          this.handleResponse(JSON.stringify(data));
        },
        error: error => {
          this.openErrorSnackbar();
        }
      });
    }, {
        useGlobalDomain: false
    });
  }

  openErrorSnackbar(message?: string): void {
    this.snackbar.openFromComponent(SnackbarMessageComponent, {
      data: {
        message: message || 'MSG.SOMETHINK_WENT_WRONG'
      },
      panelClass: 'bg-warn',
      duration: 2000
    })
  }

  handleResponse(data: string) {
    let obj = JSON.parse(data);
    if (obj.status == STATUS.SUCCESS) {
      this.router.navigate(['/auth/check-email', this.email] );
    } else if (obj.errors) {
      if (!obj.errors) return;
      const emailError = obj.errors.find(error => error.param == 'email');
      if (emailError && emailError.msg == "Email already exist") {
        this.openErrorSnackbar('MSG.EMAIL_ALREADY_EXIST');
      } else {
        this.openErrorSnackbar();
      }
    } else {
      this.openErrorSnackbar();
    }
  }

  changeLang(lang: string): void {
    this.utility.changeLang(lang);
  }

  handleSuccess(captchaResponse: string) {
    this.captchaResponse = captchaResponse;
  }
  getControl(controlName: string): AbstractControl {
    return this.registerForm.get(controlName);
  }
  toggleInput(e: HTMLInputElement): void {
    e.type = e.type == 'password' ? 'text' : 'password';
  }
  get avialableLangs(): string[] {
    return this.utility.getAvailableLang();
  }
  get currentLang(): string {
    return this.utility.getLang();
  }

  onAgree() {
    this.dialog.open(TermsDialogComponent, {
      width: '950px',
			disableClose: true,
			autoFocus: false,
      data: {
        type: 'registration'
      }
    })
    .afterClosed()
    .subscribe( result => {
      console.log(result)
      if (result) {
        this.isAgree.setValue(true)
        this.loadingService.setLoading(false)
      }
    })
  }
}
